import React from "react"
import styled from "styled-components"
import md5 from "crypto-js/md5"

const AccountIcon = ({ email, className, style }) => {
  const encryptedMail = md5(email).toString()
  const url = `https://www.gravatar.com/avatar/${encryptedMail}?s=80`

  return <img className={className} style={style} src={url} alt="" />
}

const StyledAccountIcon = styled(AccountIcon)`
  width: 36px;
  border-radius: 50%;
  border: 1px solid #fff;
  vertical-align: middle;
  margin-right: 5px;
`

export default StyledAccountIcon
